const rouConfig = [
  {
    path: 'breakfast',
    name: 'breakfast',
    meta: {
      name: '自助',
    },
    component: () => import('./index'),
  },
];

export default rouConfig;
